'use client';

import { usePathname } from 'next/navigation';

import { localeFromPath } from '../_lib/marketing-routes';
import { LpHeader } from './lp-header';
import { SiteHeader } from './site-header';

/**
 * Dünner Client-Switch für den Marketing-Header: auf Ad-Landing-Pages (`/lp/*`,
 * inkl. `/en/lp/*` + `/fr/lp/*`) den reduzierten `LpHeader` (Logo + 1 CTA, kein
 * `useUser`), sonst den vollen `SiteHeader`. `SiteHeader` bleibt unangetastet –
 * sein `useUser()`-Auth-Roundtrip läuft auf LP nie, weil er dort nicht gemountet
 * wird. Die Locale des LpHeaders kommt aus dem Pfad (DE/EN/FR-LP).
 *
 * Konvention: Künftige Ad-LPs MÜSSEN `/lp/` im Pfad haben, sonst greift der
 * Minimal-Header nicht.
 */
export function MarketingHeader() {
  const pathname = usePathname() ?? '';

  // matcht `/lp/`, `/en/lp/`, `/fr/lp/` – nicht nur die DE-Root-LPs.
  if (/\/lp\//.test(pathname)) {
    return <LpHeader locale={localeFromPath(pathname)} />;
  }

  return <SiteHeader />;
}
